import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dinheiro",
  })
  // R$ 1.000,00
  export class MoneyPipe implements PipeTransform {
    transform(
      value: any,
      decimalDelimiter: string = ",",
      decimalLength: number = 2,
      chunkDelimiter: string = ".",
      chunkLength: number = 3
    ): any {
      if (value === null || value === undefined || value === "") {
        return "";
      }
  
      if (isNaN(value)) {
        return "";
      }
      const result =
        "\\d(?=(\\d{" +
        chunkLength +
        "})+" +
        (decimalLength > 0 ? "\\D" : "R$") +
        ")";
      // tslint:disable-next-line:no-bitwise
      const num = value.toFixed(Math.max(0, ~~decimalLength));
  
      // tslint:disable-next-line:max-line-length
      return (
        "R$ " +
        (decimalDelimiter ? num.replace(".", decimalDelimiter) : num).replace(
          new RegExp(result, "g"),
          "$&" + chunkDelimiter
        )
      );
    }
  }